import React, {useEffect, useState, useRef} from 'react';
import {message, Upload, Drawer} from 'antd';
import {parseQuery} from '../../../../../utils/parseUrl';
import {useInterval} from '../../../../../utils/extHooks';
import {ESHOP_IFRAME_CONFIG} from '../../../config';
// import {uploadMulti} from '../../../utils/videoUploader';
import {uploadAIGCBgImg, transAIGCImg} from '../../../services';
import Customer from '../DigitalAnchor/Customer';
import {renameImg} from '../../../utils/imgClipHandler';
import {aiimgClickUploadLog, aiimgFilterGoodsLog} from '../../../log/ubcLog';
import EshopIframe from '../EshopIframe';
import GoodsImgList from './GoodsImgList';
import {useStore} from '../../../stores';

// import CreatePanel from './CreatePanel';

import './index.less';

const aiimgOpts = {
    actions: encodeURIComponent(JSON.stringify([{
        id: 'save',
        text: '保存到资源库'
    }])),
    uploadbtns: encodeURIComponent(JSON.stringify([{
        id: 'upload',
        text: '从店铺选择'
    }])),
    ratios: encodeURIComponent(JSON.stringify(['9-16']))
};

function getIframeUrl(isCustomer) {
    let opts = {...aiimgOpts};
    if (isCustomer) {
        opts.uploadbtns = encodeURIComponent(JSON.stringify([]));
    }
    return `https://huibo.baidu.com/aiimg?fromapp=huibo&${parseQuery(opts)}`;
}

let uploadTimer;

const AIGCImage = props => {
    const [uploadProcess, setUploadProcess] = useState(0); // 上传进度
    const [imgUrl, setImgUrl] = useState('');
    const [goodsList, setGoodsList] = useState([]);
    const [chooseGoodsVisiable, setChooseGoodsVisiable] = useState(false);
    const [goodsListVisible, setGoodsListVisible] = useState(false);
    const [showCreate, setShowCreate] = useState(false);
    const store = useStore();
    const {customerAcquisitionAuth} = store;

    const iframeRef = useRef();

    const handleGoodsSelect = goods => {
        setGoodsList(Array.isArray(goods) ? goods : [goods]);
        setChooseGoodsVisiable(false);
        setGoodsListVisible(true);

        aiimgFilterGoodsLog({
            goods_name: goods.map(item => item.title).join(','),
            goods_id: goods.map(item => item.num_id || item.spu_id || item.goods_id).join(',')
        });
    };

    const sendImgUrl = async url => {
        const res = await transAIGCImg(url).catch(e => e);

        if (res.errno === 0) {
            iframeRef.current.contentWindow.postMessage({
                type: 'IMG_CHANGE',
                data: {
                    url: res.data
                }
            }, '*');

            setGoodsListVisible(false);
        }
    };

    useInterval(() => {
        const newProcess = uploadProcess + Math.round(Math.random() * 10);
        setUploadProcess(Math.min(newProcess, 98));
    }, uploadProcess ? 500 : null);

    useEffect(() => {
        setUploadProcess(0);
        setImgUrl('');
    }, [showCreate]);

    useEffect(() => {
        // fetchMyShopGoods();
        return () => {
            setUploadProcess(0);
            setImgUrl('');
        };
    }, []);

    useEffect(
        () => {
            const openChooseGoodsDrawer = e => {
                let data = {};
                try {
                    data = JSON.parse(e.data);
                }
                catch (e) {
                    data = {};
                }

                if (data?.type === 'OPEN' && data?.data?.posid === 'upload') {
                    setChooseGoodsVisiable(true);
                }

                if (data?.type === 'BTN_CLICK' && data?.data?.list?.length) {
                    data.data.list.forEach(async item => {
                        const mood = item.mood || {};
                        const name = mood.id ? `$$ai_${mood.id + '-' + mood.name}` : '';
                        const res = await uploadAIGCBgImg({
                            name: renameImg(item.url, name),
                            bos_url: item.url,
                            url: item.url,
                            type: 1
                        });

                        if (res.errno === 0) {
                            message.success('上传成功');
                        }
                    });
                }
            };

            window.addEventListener('message', openChooseGoodsDrawer);

            return () => {
                window.removeEventListener('message', openChooseGoodsDrawer);
            };
        },
        []
    );

    return (
        <React.Fragment>
            <div className="digital-aigc-image">
                <div className="main-width">
                    <iframe ref={iframeRef} src={getIframeUrl(customerAcquisitionAuth)} />
                </div>
            </div>
            <Drawer
                visible={goodsListVisible}
                open={goodsListVisible}
                onClose={() => setGoodsListVisible(false)}
                width={990}
                destroyOnClose
            >
                <GoodsImgList
                    col={5}
                    goodsList={goodsList}
                    setImgUrl={setImgUrl}
                    setChooseGoodsVisiable={setChooseGoodsVisiable}
                    sendImgUrl={sendImgUrl}
                />
            </Drawer>

            <Drawer
                visible={chooseGoodsVisiable}
                open={chooseGoodsVisiable}
                onClose={() => {
                    setChooseGoodsVisiable(false);
                }}
                width={990}
                destroyOnClose
            >
                <EshopIframe
                    onOk={handleGoodsSelect}
                    type="live"
                    extraParams={{
                        goodsNum: 5,
                        ...{
                            ...ESHOP_IFRAME_CONFIG,
                            goodsMall: {show: false}
                        },
                        mode: 2
                    }}
                />
            </Drawer>
            <Customer />
        </React.Fragment>
    );
};

export default AIGCImage;
